import { useEffect, useState } from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableHeadCell,
  TableBodyCell,
  Button,
} from "../../../StyledComponents";
import { Div } from "../../Styles";
import { TxtSpan } from "../styles";
import Loading from "../../../StyledComponents/Loading";
import axiosInst from "../../../../Config";
import { Decrypt_Value } from "../../../../MiddleWare/EncryptDecrypt";
import EmptyData from "../../../StyledComponents/EmptyData";

const SuperBillTable = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  let backurl = "";
  let firstDot = window.location.hostname.split(".");
  let DBhost;
  if (firstDot[0] !== "localhost") {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS.replace(
      "oemr",
      firstDot[0]
    );
  } else {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS;
  }
  if (
    firstDot[0] === "localhost" ||
    firstDot[0] === "test" ||
    firstDot[0] === "mumbai" ||
    firstDot[0] === "production" ||
    firstDot[0] === "ehr" ||
    firstDot[0] === "ehr1" ||
    firstDot[0] === "dev"
  ) {
    DBhost = "default";
  } else {
    DBhost = firstDot[0];
  }

  const File_URL = backurl + "/sites/" + DBhost + "/portal_statement_documents";

  useEffect(() => {
    axiosInst
      .get(`/vozoportal/getSuperBillList?pid=${Pat_ID}`)
      .then((res) => {
        const decryptedResponse = Decrypt_Value(res.data, "vozoportal");
        setLoading(false);
        setDocuments(decryptedResponse);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const Pat_ID =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

  const handleDownload = async (url, id) => {
    const file = url;
    const fileName = "SuperBill.pdf";
    // Create a link for download
    const link = document.createElement("a");
    link.href = file;
    link.download = fileName || "Superbill.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleView = (pdfBase64) => {
    if (!pdfBase64) {
      console.error("Invalid PDF data");
      return;
    }

    // Open Base64 PDF in a new tab
    const pdfWindow = window.open();
    pdfWindow.document.write(
      `<iframe width="100%" height="100%" src="${pdfBase64}"></iframe>`
    );
  };

  return (
    <Div style={{ minHeight: "30vh" }}>
      {loading ? (
        <Loading height={40} />
      ) : (
        <Table>
          <TableHead>
            <TableRow
              display="grid"
              tempColumns="25% 25% 25% 25%"
              background="#F7F7F7"
            >
              <TableHeadCell padding="16px 0px 16px 38px">
                Provider
              </TableHeadCell>
              <TableHeadCell padding="16px 0px 16px 38px">
                Facility
              </TableHeadCell>
              <TableHeadCell padding="16px 0px 16px 38px">
                Generated On
              </TableHeadCell>
              <TableHeadCell padding="16px 0px 16px 38px">Action</TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {documents.some(
              (doc) =>
                doc &&
                (doc.provider_name ||
                  doc.facility_name ||
                  doc.document_date ||
                  doc.pdf_link)
            ) ? ( // ✅ Corrected conditional rendering
              documents.map((doc, index) => (
                <TableRow
                  key={index}
                  display="grid"
                  tempColumns="25% 25% 25% 25%"
                >
                  <TableBodyCell padding="16px 0px 16px 38px" bodered>
                    <TxtSpan
                      title={doc?.provider_name}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                        maxWidth: "180px", // adjust based on layout
                      }}
                    >
                      {doc?.provider_name || "-"}
                    </TxtSpan>
                  </TableBodyCell>
                  <TableBodyCell padding="16px 0px 16px 38px" bodered>
                    <TxtSpan
                      title={doc?.facility_name}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                        maxWidth: "180px", // adjust based on layout
                      }}
                    >
                      {doc?.facility_name || "-"}
                    </TxtSpan>
                  </TableBodyCell>
                  <TableBodyCell padding="16px 0px 16px 38px" bodered>
                    <TxtSpan>
                      {doc?.generatedDate
                        ? doc.generatedDate.split(" ")[0]
                        : "-"}
                    </TxtSpan>
                  </TableBodyCell>

                  <TableBodyCell padding="16px 0px 16px 38px" bodered>
                    <Button
                      background="#FFF"
                      borderRadius="4px"
                      color="#2C7BE5"
                      border="1px solid #2C7BE5"
                      padding="6px"
                      fontWeight="600"
                      marginRight="10px"
                      onClick={() => handleDownload(doc.pdf_url, doc.id)}
                    >
                      Download
                    </Button>
                    <Button
                      background="#2C7BE5"
                      borderRadius="4px"
                      color="#ffffff"
                      border="1px solid #2C7BE5"
                      padding="6px"
                      fontWeight="600"
                      onClick={() => handleView(doc.pdf_url)}
                    >
                      View
                    </Button>
                  </TableBodyCell>
                </TableRow>
              ))
            ) : (
              // ✅ Show empty state if no data is available
              <TableRow>
                <TableBodyCell colSpan={5} textAlign="center">
                  <EmptyData />
                </TableBodyCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}
    </Div>
  );
};

export default SuperBillTable;
